// extracted by mini-css-extract-plugin
export default {"header":"style-module--header--928a8","numberOfResults":"style-module--number-of-results--7e367"};